/**
 * Centralized Toast Notification Factory
 * Provides consistent toast UI/UX across the application
 */

import { toast } from "react-toastify";

const TOAST_CONFIG = {
  position: "top-left",
  autoClose: 5000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: false,
  progress: undefined,
  style: {
    backgroundColor: "#FFFFFF",
    color: "#000000",
  },
};

const SHORT_TOAST_CONFIG = {
  ...TOAST_CONFIG,
  autoClose: 2000,
};

const ERROR_TOAST_CONFIG = {
  ...TOAST_CONFIG,
  autoClose: 3000,
};

/**
 * Show success toast notification
 * @param {string} message - Success message
 * @param {object} options - Optional config overrides
 */
export const showSuccessToast = (message, options = {}) => {
  toast.success(message, {
    ...SHORT_TOAST_CONFIG,
    ...options,
  });
};

/**
 * Show error toast notification
 * @param {string} message - Error message
 * @param {object} options - Optional config overrides
 */
export const showErrorToast = (message, options = {}) => {
  toast.error(message, {
    ...ERROR_TOAST_CONFIG,
    ...options,
  });
};

/**
 * Show info toast notification
 * @param {string} message - Info message
 * @param {object} options - Optional config overrides
 */
export const showInfoToast = (message, options = {}) => {
  toast.info(message, {
    ...TOAST_CONFIG,
    ...options,
  });
};

/**
 * Show warning toast notification
 * @param {string} message - Warning message
 * @param {object} options - Optional config overrides
 */
export const showWarningToast = (message, options = {}) => {
  toast.warning(message, {
    ...TOAST_CONFIG,
    ...options,
  });
};
